import api from './api';

export const getUsers = async (params = {}) => {
  try {
    const queryParams = {};
    if (params.username) queryParams.username = params.username;
    if (params.email) queryParams.email = params.email;
    if (params.phone) queryParams.phone = params.phone;
    if (params.role) queryParams.role = params.role;
    if (params.status) queryParams.status = params.status;
    if (params.is_staff !== undefined) queryParams.is_staff = params.is_staff;
    if (params.search) queryParams.search = params.search;
    if (params.page) queryParams.page = params.page;
    if (params.page_size) queryParams.page_size = params.page_size;
    if (params.ordering) queryParams.ordering = params.ordering;
    const response = await api.get('/admin/users/', { params: queryParams });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch users');
  }
};

export const getUser = async (sid) => {
  try {
    const response = await api.get(`/admin/users/${sid}/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch user');
  }
};

export const createUser = async (userData) => {
  try {
    const response = await api.post('/admin/users/', userData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create user');
  }
};

export const updateUser = async (sid, userData) => {
  try {
    const response = await api.patch(`/admin/users/${sid}/`, userData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update user');
  }
};

export const promoteUser = async (sid, userData) => {
  try {
    const response = await api.post(`/admin/users/${sid}/promote/`, userData);
    return response.data;
  } catch (error) {
    const data = error.response?.data;
    throw new Error(data?.email || data?.role || data?.message || 'Failed to promote user');
  }
};

export const demoteUser = async (sid) => {
  try {
    const response = await api.post(`/admin/users/${sid}/demote/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to demote user');
  }
};

export const deleteUser = async (sid) => {
  try {
    await api.delete(`/admin/users/${sid}/`);
    return true;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete user');
  }
};

export const getUserStats = async () => {
  try {
    const response = await api.get('/admin/users/stats/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch user stats');
  }
};

export const getUserAcquisitionAnalytics = async () => {
  try {
    const response = await api.get('/admin/users/acquisition-analytics/');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch user acquisition analytics');
  }
};
